import React from 'react';
import Chats from './Chats';
import InputContainer from './InputContainer';
import ClearConversation from './ClearConversation';
import { useSelector, useDispatch } from 'react-redux';
// import TabSelector from './TabSelector';
import styled from 'styled-components';
import classNames from 'classnames';
import { modes } from 'app.config';

function SmallScreenHistory(props) {
  const { hisRef } = props;

  // const [tab, setTab] = useState(0);

  const dispatch = useDispatch();

  const open = useSelector(state => state.utils.openMobileChatMenu);
  const mode = useSelector(state => state.utils.mode);

  const handleClose = () => {
    dispatch.utils.setOpenMobileChatMenu(false);
  };

  return (
    <Container
      className={classNames('small__screen-history', 'chat-modal')}
      style={{ display: open ? 'flex' : 'none' }}
    >
      <div ref={hisRef} />
      <div className='history-wrapper'>
        <div className='history_grid'>
          <div className='d-flex justify-content-between align-items-center mx-2'>
            <a
              href='https://help.chatai.com/hc/en-us'
              target='_blank'
              rel='noreferrer'
            >
              <div className='support-grid'>
                <svg
                  width='18'
                  height='17'
                  viewBox='0 0 18 17'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12.7632 13.5474H9.62636L6.13661 15.8687C6.01883 15.9472 5.88196 15.9923 5.74058 15.9991C5.5992 16.0059 5.45862 15.9742 5.33385 15.9074C5.20907 15.8406 5.10477 15.7411 5.03207 15.6197C4.95938 15.4983 4.92101 15.3594 4.92107 15.2178V13.5474C2.56843 13.5474 1 11.979 1 9.62636V4.92107C1 2.56843 2.56843 1 4.92107 1H12.7632C15.1159 1 16.6843 2.56843 16.6843 4.92107V9.62636C16.6843 11.979 15.1159 13.5474 12.7632 13.5474Z'
                    stroke='white'
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M8.84208 8.00303V7.83835C8.84208 7.30508 9.17145 7.02277 9.50082 6.79534C9.82235 6.57576 10.1439 6.29345 10.1439 5.77587C10.1439 5.05439 9.56356 4.47407 8.84208 4.47407C8.1206 4.47407 7.54028 5.05439 7.54028 5.77587M8.83816 9.87731H8.846'
                    stroke='white'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
            </a>

            <div
              className='close-box'
              style={{ marginTop: '10px' }}
              onClick={handleClose}
            >
              <svg
                width='20'
                height='20'
                viewBox='0 0 10 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M4.18036 3.32412L6.80021 0.70634L6.09282 -0.000488281L3.47297 2.6173L0.853625 7.21216e-06L0.14624 0.706836L2.76559 3.32412L0.14624 5.94141L0.853625 6.64824L3.47297 4.03095L6.09282 6.64874L6.80021 5.94191L4.18036 3.32412Z'
                  fill='white'
                />
              </svg>
            </div>
          </div>
          {/* <div style={{ paddingRight: '10px' }}>
            <TabSelector tab={tab} setTab={setTab} />
          </div> */}
          <Chats />
          <InputContainer />
        </div>
        <div>{mode !== modes.document && <ClearConversation />}</div>
      </div>
    </Container>
  );
}

export default SmallScreenHistory;

const Container = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 40;
  background-color: ${({ theme }) => theme.colors.darkgray};

  & .history_grid {
    overflow: hidden;
  }
`;
